import { Recorder, Voice } from '@weblite/voice-recorder'
import { t } from '$i18n'
import { showErrorSnackbar } from '$comp/snackbars'
import { convertVoiceToFile } from '$logic/message'
import { getVoiceWave } from '$helper/functions/voice-wave'

const config = {
  wasmURL: '/assets/vmsg/vmsg.wasm',
  shimURL: '/assets/vmsg/wasm-polyfill.js',
}

const recorder = new Recorder(config)

export const VoiceRecorder = {
  isRecording: false,
  start: async () => {
    if (VoiceRecorder.isRecording) {
      showErrorSnackbar(t('snackbar.voiceRecorder.alreadyRecording'))
      throw new Error(t('snackbar.voiceRecorder.alreadyRecording'))
    }
    await recorder.start()
    VoiceRecorder.isRecording = true
  },
  stop: async (): Promise<Voice> => {
    const voice = await recorder.stop()
    VoiceRecorder.isRecording = false
    return voice
  },
  getRecordedVoiceWave: async (voice: Voice): Promise<number[]> => {
    const file = convertVoiceToFile(voice)
    const wave = await getVoiceWave(file)
    return wave
  },
}
